export default __webpack_public_path__ + "images/orbits.5e96dd9e4b31063621e7e10dff52e1f0.png";